import MenuItem from '@material-ui/core/MenuItem';
import React from 'react';
import moment from 'moment';

export const capitalizeFLetter = string => {
  return string[0].toUpperCase() + string.slice(1);
};

export const isValidEmail = value => {
  return value && /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,8}$/i.test(value);
};

export const idGenerator = () => {
  return Math.floor(Math.random() * 100000);
};

export const linkify = inputText => {
  var replacedText, replacePattern1, replacePattern2, replacePattern3;

  //URLs starting with http://, https://, or ftp://
  replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\\/%?=~_|!:,.;]*[-A-Z0-9+&@#\\/%=~_|])/gim;
  replacedText = inputText.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');

  //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
  replacePattern2 = /(^|[^\\/])(www\.[\S]+(\b|$))/gim;
  replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');

  //Change email addresses to mailto:: links.
  replacePattern3 = /(([a-zA-Z0-9\-_.])+@[a-zA-Z0-9\\-]+?(\.[a-zA-Z]{2,6})+)/gim;
  replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');

  return replacedText;
};

export const geValidUrl = (url, ubSecureUrl = false) => {
  if (!url.match(/^[a-zA-Z]+:\/\//)) {
    if (ubSecureUrl) {
      return 'http://' + url;
    }
    return 'https://' + url;
  }

  return url;
};

const dayinWeekEn = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const dayinWeekDe = ['Son', 'Mon', 'Die', 'Mit', 'Don', 'Fre', 'Sam'];
const dayinWeekSl = ['Ned', 'Pon', 'Tor', 'Sre', 'Čet', 'Pet', 'Sob'];
const dayinWeekIt = ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'];
const dayinWeekHr = ['Ned', 'Pon', 'Uto', 'Sri', 'Čet', 'Pet', 'Sub'];
const dayinWeekSr = ['Ned', 'Pon', 'Uto', 'Sre', 'Čet', 'Pet', 'Sub'];
const monthEn = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const monthDe = ['Jan', 'Feb', 'Mar', 'Apr', 'Kan', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'];
const monthIt = ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'];
const monthSl = ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Avg', 'Sep', 'Okt', 'Nov', 'Dec'];
const monthHr = ['Sij', 'Velj', 'Ožu', 'Tra', 'Svi', 'Lip', 'Srp', 'Kol', 'Ruj', 'Lis', 'Stu', 'Pro'];
const monthSr = ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Avg', 'Sep', 'Okt', 'Nov', 'Dec'];

export const getMonth = (month, lang) => {
  var d2 = '';
  if (lang == 'hr') d2 = monthHr[month];
  else if (lang == 'sl') d2 = monthSl[month];
  else if (lang == 'de') d2 = monthDe[month];
  else if (lang == 'sr') d2 = monthSr[month];
  else if (lang == 'it') d2 = monthIt[month];
  else d2 = monthEn[month];
  return d2;
};

export const getMyDateInWeek = (mydate, lang) => {
  var d = new Date(mydate);
  var d1 = '',
    d2 = '';
  if (lang == 'hr') d1 = dayinWeekHr[d.getDay()];
  else if (lang == 'sr') d1 = dayinWeekSr[d.getDay()];
  else d1 = dayinWeekEn[d.getDay()];

  return d1;
};

export const dateRange = (startDate, endDate, steps = 1, perDay = false) => {
  const dateArray = [];
  let currentDate = new moment(startDate);
  //  console.log(steps);
  while (currentDate <= new moment(endDate)) {
    var endDate2 = new moment(currentDate);
    //endDate2.setUTCDate(endDate2.getUTCDate() + (steps - 1));

    if (steps == 30) {
      endDate2.endOf('month');
      //endDate2.setutcFullYear(currentDate.getUTCFullYear(), currentDate.getUTCMonth() + 1, 0);
    } else endDate2.add(steps, 'days');
    /*  console.log('current' + currentDate);
    console.log('end2' + endDate2);*/
    if (perDay) {
      dateArray.push(currentDate.format('YYYY-MM-DD'));
    } else
      dateArray.push({
        s: currentDate.format('YYYY-MM-DD'), //new Date(currentDate).toISOString().slice(0, 10),
        e: endDate2.format('YYYY-MM-DD'), //new Date(endDate2).toISOString().slice(0, 10),
      });
    //  console.log(dateArray);
    // Use UTC date to prevent problems with time zones and DST
    //currentDate.setUTCDate(currentDate.getUTCDate() + steps);
    //currentDate.setUTCDate(endDate2.getUTCDate() + 1);
    currentDate.set(endDate2.toObject());
    currentDate.add(1, 'days');
    endDate2.add(1, 'days');
    /*if (steps == 30) {
      var z1 = endDate2.getUTCFullYear();
      var z2 = endDate2.getUTCMonth() + 2;
      if (z2 > 12) {
        z1++;
        z2 = 1;
      }
      currentDate.setFullYear(z1, z2, 1);
    }*/
  }

  /*console.log('dateawray');
  console.log(startDate);
  console.log(endDate);
  console.log(dateArray);*/

  return dateArray;
};

export const getMyDate1 = (mydate, lang) => {
  if (String(mydate).length == 10) mydate = mydate + 'T00:00:00';
  var d = new Date(mydate);
  var d1 = '',
    d2 = '';
  if (lang == 'hr') d1 = dayinWeekHr[d.getDay()];
  else if (lang == 'sr') d1 = dayinWeekSr[d.getDay()];
  else d1 = dayinWeekEn[d.getDay()];

  if (lang == 'hr') d2 = monthHr[d.getMonth()];
  else if (lang == 'sr') d2 = monthSr[d.getMonth()];
  else d2 = monthEn[d.getMonth()];

  return '<b>' + d1 + ' ' + d.getDate() + '</b><br/>' + d2; // + ' ' + d.getFullYear();
};

export const getMyDate2 = (mydate, lang) => {
  if (mydate == null) return '-';
  if (String(mydate).length == 10) mydate = mydate + 'T00:00:00';
  var d = new Date(mydate);
  // console.log(d);
  var d1 = '',
    d2 = '';
  if (lang == 'hr') d1 = dayinWeekHr[d.getDay()];
  else if (lang == 'sl') d1 = dayinWeekSl[d.getDay()];
  else if (lang == 'de') d1 = dayinWeekDe[d.getDay()];
  else if (lang == 'sr') d1 = dayinWeekSr[d.getDay()];
  else if (lang == 'it') d1 = dayinWeekIt[d.getDay()];
  else d1 = dayinWeekEn[d.getDay()];

  if (lang == 'hr') d2 = monthHr[d.getMonth()];
  else if (lang == 'sl') d2 = monthSl[d.getMonth()];
  else if (lang == 'de') d2 = monthDe[d.getMonth()];
  else if (lang == 'sr') d2 = monthSr[d.getMonth()];
  else if (lang == 'it') d2 = monthIt[d.getMonth()];
  else d2 = monthEn[d.getMonth()];
  return '' + d1 + ', ' + d.getDate() + ' ' + d2 + ' ' + d.getFullYear();
};

export const getMyDate3 = (mydate, lang) => {
  if (mydate == null) return '';

  var d = new Date(mydate);
  var d1 = '',
    d2 = '';
  if (lang == 'hr') d1 = dayinWeekHr[d.getDay()];
  else if (lang == 'sr') d1 = dayinWeekSr[d.getDay()];
  else d1 = dayinWeekEn[d.getDay()];

  if (lang == 'hr') d2 = monthHr[d.getMonth()];
  else if (lang == 'sr') d2 = monthSr[d.getMonth()];
  else d2 = monthEn[d.getMonth()];

  return (
    '' +
    d1 +
    ', ' +
    d.getDate() +
    ' ' +
    d2 +
    ' ' +
    d.getFullYear() +
    ' ' +
    ('0' + d.getHours()).slice(-2) +
    ':' +
    ('0' + d.getMinutes()).slice(-2)
  );
};

export const getMyDate = prop => {
  //prop = prop + 'T00:00:00';
  if (String(prop).length == 10) prop = prop + 'T00:00:00';
  var md = new Date(prop);

  var dd = String(md.getDate()).padStart(2, '0');
  var mm = String(md.getMonth() + 1).padStart(2, '0');
  var yyyy = md.getFullYear();
  return yyyy + '-' + mm + '-' + dd;
};

export const getMyTime3 = prop => {
  var md = new Date(prop);
  var dd = String(md.getHours()).padStart(2, '0');
  var mm = String(md.getMinutes()).padStart(2, '0');
  return dd + ':' + mm;
};

export const getMyTime = (time1, time2) => {
  var d1 = new Date(time1);
  var d2 = new Date(time2);

  var s1 = String(d1.getHours()).padStart(2, '0') + ':' + String(d1.getMinutes()).padStart(2, '0');
  var s2 = String(d2.getHours()).padStart(2, '0') + ':' + String(d2.getMinutes()).padStart(2, '0');
  return s1 + ' - ' + s2;
};

export const getMyTime2 = (time1, time2) => {
  var d1 = new Date(time1);
  var d2 = new Date(time2);
  var diff = (d1.getTime() - d2.getTime()) / 1000;
  diff /= 60 * 60;
  return Math.abs(Math.round(diff));
};

export const getMyDate4 = (mydate, lang) => {
  if (String(mydate).length == 10) mydate = mydate + 'T00:00:00';
  var md = new Date(mydate);
  var dd = String(md.getDate());
  var mm = String(md.getMonth() + 1);
  var yyyy = md.getFullYear();
  return dd + '.' + mm + '.' + yyyy + '.';
};

export const getMyDate5 = (mydate, lang) => {
  var md = new Date(mydate);
  var dd = String(md.getDate());
  var mm = String(md.getMonth() + 1);
  var yyyy = md.getFullYear();
  if (lang == 'hr') return dd + '.' + mm + '.';
  else return mm + '-' + dd;
};

export const getMyDate6 = (mydate, lang) => {
  if (String(mydate).length == 10) mydate = mydate + 'T00:00:00';
  var md = new Date(mydate);
  var dd = String(md.getDate()).padStart(2, '0');
  var mm = String(md.getMonth() + 1).padStart(2, '0');
  var yyyy = md.getFullYear();
  if (lang == 'hr') return dd + '' + mm + '' + yyyy;
  else return yyyy + '' + mm + '' + dd;
};

export const formatPrice = (price, lang, decimals) => {
  var priceint = parseFloat(price);
  var myDecimls = 2;
  if (decimals != undefined) myDecimls = decimals;
  if (lang == 'hr') {
    return priceint.toLocaleString('hr-HR', { minimumFractionDigits: myDecimls, maximumFractionDigits: myDecimls });
  } else if (lang == 'sr') {
    return priceint.toLocaleString('sr-RS', { minimumFractionDigits: myDecimls, maximumFractionDigits: myDecimls });
  } else {
    return priceint.toLocaleString('en-US', { minimumFractionDigits: myDecimls, maximumFractionDigits: myDecimls });
  }
};

export const getMyTime4 = time1 => {
  var b = time1.split(/\D/);
  var d1 = new Date(b[0], b[1] - 1, b[2], b[3], b[4], b[5]);

  //var d1 = new Date(time1);
  var today = new Date();
  var s1 = '';
  if (getMyDate(time1) != getMyDate(today)) s1 = getMyDate4(d1, 'hr') + ' ';

  s1 = s1 + String(d1.getHours()).padStart(2, '0') + ':' + String(d1.getMinutes()).padStart(2, '0');
  return s1;
};

export const dateDiffInDays = (a, b) => {
  // Discard the time and time-zone information.
  const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
  const _MS_PER_DAY = 1000 * 60 * 60 * 24;
  return Math.abs(Math.floor((utc2 - utc1) / _MS_PER_DAY));
};

export const dateDiffInHours = b => {
  const utc1 = Date.now();
  const utc2 = Date.parse(b);
  const _MS_PER_DAY = 1000 * 60 * 60;
  return Math.abs(Math.floor((utc2 - utc1) / _MS_PER_DAY));
};

export const myFormatDate = (mydate, mode) => {
  var md = new Date(mydate);
  var dd = String(md.getDate());
  var mm = String(md.getMonth() + 1);
  var yyyy = md.getFullYear();
  if (mode == 0) return dd + '/' + mm + '/' + yyyy;
  if (mode == 1) return dd + '.' + mm + '.' + yyyy;
  if (mode == 2) return dd + '-' + mm + '-' + yyyy;
  if (mode == 3) return mm + '/' + dd + '/' + yyyy;
  if (mode == 4) return mm + '-' + dd + '-' + yyyy;
  if (mode == 5) return yyyy + '-' + mm + '-' + dd;
};

export const myFormatDate2 = mode => {
  if (mode == 0) return 'DD/MM/yyyy';
  if (mode == 1) return 'DD.MM.yyyy';
  if (mode == 2) return 'DD-MM-yyyy';
  if (mode == 3) return 'MM/DD/yyyy';
  if (mode == 4) return 'MM-DD-yyyy';
  if (mode == 5) return 'yyyy-MM-DD';
};

export const myFormatPrice = (price, mode, removeThousand = 0, zeroEmpty = 0) => {
  var priceint = parseFloat(price);
  var myDecimls = 2;
  if (zeroEmpty == 1 && priceint == 0) return '';
  if (mode == 0) {
    var x = priceint.toLocaleString('hr-HR', { minimumFractionDigits: myDecimls, maximumFractionDigits: myDecimls });
    if (removeThousand == 1) x = String(x).replace('.', '');
    return x;
  } else {
    var x = priceint.toLocaleString('en-US', { minimumFractionDigits: myDecimls, maximumFractionDigits: myDecimls });
    if (removeThousand == 1) x = String(x).replace(',', '');
    return x;
  }
};

export const myGetNumber = (price, mode) => {
  if (price == '') return String(0);
  if (mode == 0) {
    price = String(price).replace('.', '');
    price = String(price).replace(',', '.');
  }
  if (mode == 1) {
    price = String(price).replace(',', '');
  }

  var priceint = parseFloat(price);
  var p = priceint.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  p = String(p).replace(',', '');
  return p;
};

export const getSameDayOfYear = (date, yearsToAdd, correct = true) => {
  console.log('xx');
  console.log(date);
  date = typeof date === 'string' ? new Date(date) : date;
  var retDate = new Date(+date);
  retDate.setYear(retDate.getFullYear() + yearsToAdd);

  var diff = date.getDay() - retDate.getDay();
  if (diff < -4) {
    diff = diff + 7; //go forward instead of backward
  }

  if (correct) retDate.setDate(retDate.getDate() + diff);
  //console.log(retDate.toLocaleDateString());
  return new moment(retDate);
};

export const timeDifference = (date1, minutes = false) => {
  // Convert inputs to Date objects if they aren't already
  if (date1 == null) return;
  const d1 = new Date(date1);
  const d2 = new Date();

  // Calculate the difference in milliseconds
  const diffMs = Math.abs(d2 - d1);

  // Convert to seconds
  const diffSeconds = Math.floor(diffMs / 1000);

  if (minutes) {
    if (diffSeconds < 60 * 15) return true;
    else return false;
  }

  if (diffSeconds < 60) {
    return `${diffSeconds} second${diffSeconds !== 1 ? 's' : ''}`;
  }

  const diffMinutes = Math.floor(diffSeconds / 60);
  if (diffMinutes < 60) {
    return `${diffMinutes} minute${diffMinutes !== 1 ? 's' : ''}`;
  }

  const diffHours = Math.floor(diffMinutes / 60);
  if (diffHours < 24) {
    return `${diffHours} hour${diffHours !== 1 ? 's' : ''}`;
  }

  const diffDays = Math.floor(diffHours / 24);
  return `${diffDays} day${diffDays !== 1 ? 's' : ''}`;
};

export const countriesx = [
  { id: 'AF', value: 'Afghanistan' },
  { id: 'AX', value: 'Åland Islands' },
  { id: 'AL', value: 'Albania' },
  { id: 'DZ', value: 'Algeria' },
  { id: 'AS', value: 'American Samoa' },
  { id: 'AD', value: 'Andorra' },
  { id: 'AO', value: 'Angola' },
  { id: 'AI', value: 'Anguilla' },
  { id: 'AQ', value: 'Antarctica' },
  { id: 'AG', value: 'Antigua and Barbuda' },
  { id: 'AR', value: 'Argentina' },
  { id: 'AM', value: 'Armenia' },
  { id: 'AW', value: 'Aruba' },
  { id: 'AU', value: 'Australia' },
  { id: 'AT', value: 'Austria' },
  { id: 'AZ', value: 'Azerbaijan' },
  { id: 'BS', value: 'Bahamas' },
  { id: 'BH', value: 'Bahrain' },
  { id: 'BD', value: 'Bangladesh' },
  { id: 'BB', value: 'Barbados' },
  { id: 'BY', value: 'Belarus' },
  { id: 'BE', value: 'Belgium' },
  { id: 'BZ', value: 'Belize' },
  { id: 'BJ', value: 'Benin' },
  { id: 'BM', value: 'Bermuda' },
  { id: 'BT', value: 'Bhutan' },
  { id: 'BO', value: 'Bolivia' },
  { id: 'BQ', value: 'Bonaire, Sint Eustatius and Saba' },
  { id: 'BA', value: 'Bosnia and Herzegowina' },
  { id: 'BW', value: 'Botswana' },
  { id: 'BV', value: 'Bouvet Island' },
  { id: 'BR', value: 'Brazil' },
  { id: 'IO', value: 'British Indian Ocean Territory' },
  { id: 'VG', value: 'British Virgin Islands' },
  { id: 'BN', value: 'Brunei Darussalam' },
  { id: 'BG', value: 'Bulgaria' },
  { id: 'BF', value: 'Burkina Faso' },
  { id: 'BI', value: 'Burundi' },
  { id: 'KH', value: 'Cambodia' },
  { id: 'CM', value: 'Cameroon' },
  { id: 'CA', value: 'Canada' },
  { id: 'CV', value: 'Cape Verde' },
  { id: 'KY', value: 'Cayman Islands' },
  { id: 'CF', value: 'Central African Republic' },
  { id: 'TD', value: 'Chad' },
  { id: 'CL', value: 'Chile' },
  { id: 'CN', value: 'China' },
  { id: 'CX', value: 'Christmas Island' },
  { id: 'CC', value: 'Cocos (Keeling) Islands' },
  { id: 'CO', value: 'Colombia' },
  { id: 'KM', value: 'Comoros' },
  { id: 'CD', value: 'Congo, The Democratic Republic of the' },
  { id: 'CK', value: 'Cook Islands' },
  { id: 'CR', value: 'Costa Rica' },
  { id: 'CI', value: "Cote D'ivoire" },
  { id: 'HR', value: 'Croatia' },
  { id: 'CU', value: 'Cuba' },
  { id: 'CW', value: 'Curaçao' },
  { id: 'CY', value: 'Cyprus' },
  { id: 'CZ', value: 'Czech Republic' },
  { id: 'DK', value: 'Denmark' },
  { id: 'DJ', value: 'Djibouti' },
  { id: 'DM', value: 'Dominica' },
  { id: 'DO', value: 'Dominican Republic' },
  { id: 'TL', value: 'East Timor' },
  { id: 'EC', value: 'Ecuador' },
  { id: 'EG', value: 'Egypt' },
  { id: 'SV', value: 'El Salvador' },
  { id: 'GQ', value: 'Equatorial Guinea' },
  { id: 'ER', value: 'Eritrea' },
  { id: 'EE', value: 'Estonia' },
  { id: 'ET', value: 'Ethiopia' },
  { id: 'FK', value: 'Falkland Islands (Malvinas)' },
  { id: 'FO', value: 'Faroe Islands' },
  { id: 'FJ', value: 'Fiji' },
  { id: 'FI', value: 'Finland' },
  { id: 'FR', value: 'France' },
  { id: 'GF', value: 'French Guiana' },
  { id: 'PF', value: 'French Polynesia' },
  { id: 'TF', value: 'French Southern Territories' },
  { id: 'GA', value: 'Gabon' },
  { id: 'GM', value: 'Gambia' },
  { id: 'GE', value: 'Georgia' },
  { id: 'DE', value: 'Germany' },
  { id: 'GH', value: 'Ghana' },
  { id: 'GI', value: 'Gibraltar' },
  { id: 'GR', value: 'Greece' },
  { id: 'GL', value: 'Greenland' },
  { id: 'GD', value: 'Grenada' },
  { id: 'GP', value: 'Guadeloupe' },
  { id: 'GU', value: 'Guam' },
  { id: 'GT', value: 'Guatemala' },
  { id: 'GG', value: 'Guernsey' },
  { id: 'GN', value: 'Guinea' },
  { id: 'GW', value: 'Guinea-Bissau' },
  { id: 'GY', value: 'Guyana' },
  { id: 'HT', value: 'Haiti' },
  { id: 'HM', value: 'Heard and McDonald Islands' },
  { id: 'HN', value: 'Honduras' },
  { id: 'HK', value: 'Hong Kong' },
  { id: 'HU', value: 'Hungary' },
  { id: 'IS', value: 'Iceland' },
  { id: 'IN', value: 'India' },
  { id: 'ID', value: 'Indonesia' },
  { id: 'IQ', value: 'Iraq' },
  { id: 'IE', value: 'Ireland' },
  { id: 'IR', value: 'Islamic Republic of Iran' },
  { id: 'IM', value: 'Isle of Man' },
  { id: 'IL', value: 'Israel' },
  { id: 'IT', value: 'Italy' },
  { id: 'JM', value: 'Jamaica' },
  { id: 'JP', value: 'Japan' },
  { id: 'JE', value: 'Jersey' },
  { id: 'JO', value: 'Jordan' },
  { id: 'KZ', value: 'Kazakhstan' },
  { id: 'KE', value: 'Kenya' },
  { id: 'KI', value: 'Kiribati' },
  { id: 'KP', value: 'Korea, Dem. Peoples Rep of' },
  { id: 'KR', value: 'Korea, Republic of' },
  { id: 'KW', value: 'Kuwait' },
  { id: 'KG', value: 'Kyrgyzstan' },
  { id: 'LA', value: 'Laos' },
  { id: 'LV', value: 'Latvia' },
  { id: 'LB', value: 'Lebanon' },
  { id: 'LS', value: 'Lesotho' },
  { id: 'LR', value: 'Liberia' },
  { id: 'LY', value: 'Libyan Arab Jamahiriya' },
  { id: 'LI', value: 'Liechtenstein' },
  { id: 'LT', value: 'Lithuania' },
  { id: 'LU', value: 'Luxembourg' },
  { id: 'MO', value: 'Macau' },
  { id: 'MK', value: 'Macedonia' },
  { id: 'MG', value: 'Madagascar' },
  { id: 'MW', value: 'Malawi' },
  { id: 'MY', value: 'Malaysia' },
  { id: 'MV', value: 'Maldives' },
  { id: 'ML', value: 'Mali' },
  { id: 'MT', value: 'Malta' },
  { id: 'MH', value: 'Marshall Islands' },
  { id: 'MQ', value: 'Martinique' },
  { id: 'MR', value: 'Mauritania' },
  { id: 'MU', value: 'Mauritius' },
  { id: 'YT', value: 'Mayotte' },
  { id: 'MX', value: 'Mexico' },
  { id: 'FM', value: 'Micronesia' },
  { id: 'MD', value: 'Moldova, Republic of' },
  { id: 'MC', value: 'Monaco' },
  { id: 'MN', value: 'Mongolia' },
  { id: 'ME', value: 'Montenegro' },
  { id: 'MS', value: 'Montserrat' },
  { id: 'MA', value: 'Morocco' },
  { id: 'MZ', value: 'Mozambique' },
  { id: 'MM', value: 'Myanmar' },
  { id: 'NA', value: 'Namibia' },
  { id: 'NR', value: 'Nauru' },
  { id: 'NP', value: 'Nepal' },
  { id: 'NL', value: 'Netherlands' },
  { id: 'AN', value: 'Netherlands Antilles' },
  { id: 'NC', value: 'New Caledonia' },
  { id: 'NZ', value: 'New Zealand' },
  { id: 'NI', value: 'Nicaragua' },
  { id: 'NE', value: 'Niger' },
  { id: 'NG', value: 'Nigeria' },
  { id: 'NU', value: 'Niue' },
  { id: 'NF', value: 'Norfolk Island' },
  { id: 'MP', value: 'Northern Mariana Islands' },
  { id: 'NO', value: 'Norway' },
  { id: 'OM', value: 'Oman' },
  { id: 'PK', value: 'Pakistan' },
  { id: 'PW', value: 'Palau' },
  { id: 'PS', value: 'Palestine, State of' },
  { id: 'PA', value: 'Panama' },
  { id: 'PG', value: 'Papua New Guinea' },
  { id: 'PY', value: 'Paraguay' },
  { id: 'PE', value: 'Peru' },
  { id: 'PH', value: 'Philippines' },
  { id: 'PN', value: 'Pitcairn' },
  { id: 'PL', value: 'Poland' },
  { id: 'PT', value: 'Portugal' },
  { id: 'PR', value: 'Puerto Rico' },
  { id: 'QA', value: 'Qatar' },
  { id: 'RE', value: 'Reunion' },
  { id: 'RO', value: 'Romania' },
  { id: 'RU', value: 'Russian Federation' },
  { id: 'RW', value: 'Rwanda' },
  { id: 'BL', value: 'Saint Barthélemy' },
  { id: 'LC', value: 'Saint Lucia' },
  { id: 'MF', value: 'Saint Martin (French part)' },
  { id: 'WS', value: 'Samoa' },
  { id: 'SM', value: 'San Marino' },
  { id: 'ST', value: 'Sao Tome and Principe' },
  { id: 'SA', value: 'Saudi Arabia' },
  { id: 'SN', value: 'Senegal' },
  { id: 'RS', value: 'Serbia' },
  { id: 'SC', value: 'Seychelles' },
  { id: 'SL', value: 'Sierra Leone' },
  { id: 'SG', value: 'Singapore' },
  { id: 'SX', value: 'Sint Maarten (Dutch part)' },
  { id: 'SK', value: 'Slovakia' },
  { id: 'SI', value: 'Slovenia' },
  { id: 'SB', value: 'Solomon Islands' },
  { id: 'SO', value: 'Somalia' },
  { id: 'ZA', value: 'South Africa' },
  { id: 'GS', value: 'South Georgia and the South Sandwich Islands' },
  { id: 'SS', value: 'South Sudan' },
  { id: 'ES', value: 'Spain' },
  { id: 'LK', value: 'Sri Lanka' },
  { id: 'SH', value: 'St. Helena' },
  { id: 'KN', value: 'St. Kitts and Nevis' },
  { id: 'PM', value: 'St. Pierre and Miquelon' },
  { id: 'VC', value: 'St. Vincent and the Grenadines' },
  { id: 'SD', value: 'Sudan' },
  { id: 'SR', value: 'Suriname' },
  { id: 'SJ', value: 'Svalbard and Jan Mayen Islands' },
  { id: 'SZ', value: 'Swaziland' },
  { id: 'SE', value: 'Sweden' },
  { id: 'CH', value: 'Switzerland' },
  { id: 'SY', value: 'Syrian Arab Republic' },
  { id: 'TW', value: 'Taiwan' },
  { id: 'TJ', value: 'Tajikistan' },
  { id: 'TZ', value: 'Tanzania, United Republic of' },
  { id: 'TH', value: 'Thailand' },
  { id: 'TG', value: 'Togo' },
  { id: 'TK', value: 'Tokelau' },
  { id: 'TO', value: 'Tonga' },
  { id: 'TT', value: 'Trinidad and Tobago' },
  { id: 'TN', value: 'Tunisia' },
  { id: 'TR', value: 'Turkey' },
  { id: 'TM', value: 'Turkmenistan' },
  { id: 'TC', value: 'Turks and Caicos Islands' },
  { id: 'TV', value: 'Tuvalu' },
  { id: 'UG', value: 'Uganda' },
  { id: 'UA', value: 'Ukraine' },
  { id: 'AE', value: 'United Arab Emirates' },
  { id: 'GB', value: 'United Kingdom' },
  { id: 'US', value: 'United States' },
  { id: 'UM', value: 'United States Minor Outlying Islands' },
  { id: 'VI', value: 'United States Virgin Islands' },
  { id: 'UY', value: 'Uruguay' },
  { id: 'UZ', value: 'Uzbekistan' },
  { id: 'VU', value: 'Vanuatu' },
  { id: 'VA', value: 'Vatican City State' },
  { id: 'VE', value: 'Venezuela' },
  { id: 'VN', value: 'Vietnam' },
  { id: 'WF', value: 'Wallis And Futuna Islands' },
  { id: 'EH', value: 'Western Sahara' },
  { id: 'YE', value: 'Yemen' },
  { id: 'ZR', value: 'Zaire' },
  { id: 'ZM', value: 'Zambia' },
  { id: 'ZW', value: 'Zimbabwe' },
];

// Example usage:
